

export enum DetectedSensitiveWordState {
    New = 0,
    InvestigationPending = 1,
    Ignore = 2,
    Block = 3
}

export default DetectedSensitiveWordState




